// extracted by mini-css-extract-plugin
module.exports = {"entity":"Entity_entity__2aIEn","gridContainer":"Entity_gridContainer__lpzMp","icon":"Entity_icon__2lfql","content":"Entity_content__3yFyJ","value":"Entity_value__3MGZC"};